import { 
  Component, 
  OnInit, 
  ViewChild, 
  ElementRef, 
  Output, 
  EventEmitter, 
  Input, 
  ChangeDetectionStrategy, ChangeDetectorRef, SimpleChanges 
} from '@angular/core';

declare var paypal;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'paypal-elements',
  templateUrl: './elements.component.html',
  styleUrls: ['./elements.component.scss'],
})
export class ElementsComponent implements OnInit {

  @ViewChild('paypal', {static: true})
  element: ElementRef;

  paidFor: boolean = false;
  
  
  @Input() locale: string;
  @Input() amount: number;
  @Input() description: string;
  
  @Output() result = new EventEmitter();

  constructor(
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    paypal.Buttons({
      locale: this.locale||'en_US',
      style: {
        label: 'pay',
        fundingicons: 'true',
        shape: 'pill',
        color: 'silver'
      },
      funding: {
        allowed: [ paypal.FUNDING.VENMO, paypal.FUNDING.CARD, paypal.FUNDING.CREDIT ],
        disallowed: [  ]
      },
      createOrder: (data, actions) => {
        return actions.order.create({
          purchase_units: [{
            description: this.description||'Purchase Items',
            amount: {
              currency_code: 'USD',
              value: this.amount
            }
          }]
        });
      },
      onApprove: async (data, actions) => {
        const order = await actions.order.capture();
        this.paidFor = true;
        this.result.emit(order);
      },
      onError: err => {
        // console.log(err);
      }
    })
    .render(this.element.nativeElement);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // changes to config
    if (!changes.config.isFirstChange()) {
      this.cdr.detectChanges();
    }
  }

}
